module.exports = __webpack_public_path__ + "img/img15.c378ad00.png";